import { Injectable } from '@angular/core';
import { Router } from "@angular/router";
import { HttpClient } from '@angular/common/http';


import { KappaEndpoint } from './kappa-endpoint.service';



@Injectable({ providedIn: 'root'})
export class KappaService {

  constructor(private router: Router, private http: HttpClient, private kappaEndpoint: KappaEndpoint) {

  }

  getKappaTypes() {
    return this.kappaEndpoint.getKappaTypesEndpoint<any>();
  }


}
